import React, { useCallback, useEffect } from "react";
import { Container } from "@material-ui/core";
import Title from "../../ui/Title";
import { MANAGER_ROUTES } from "../../utils/constants";
import { useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { common } from "../../messages";
import { useBmapi } from "../../utils/bmapi-context";
import { getErrorMessageString } from "../../utils/errors";
import { intlFormatMessage } from "../../utils/utils";
import { distributionLists } from "../../messages/distributionLists";
import DistributionListForm from "../../ui/forms/DistributionListForm";

export default function DistributionListEdit() {
  const { listId } = useParams();
  const initialValues = {
    dynamic: false,
    name: "",
    static_list: [],
    gender: "ALL",
    age_from: 16,
    age_to: 100,
    consents: [],
    consent_id: "",
    consent_value: false,
    import_csv: "false",
  };
  const [values, setValues] = React.useState(initialValues);

  const intl = useIntl();
  const { bmapi, notifyError } = useBmapi();
  const [listType, setListType] = React.useState("");
  const [consentsList, setConsentsList] = React.useState([]);

  const staticType = listType === "static";
  const dynamicType = listType === "dynamic";

  const loadList = useCallback(() => {
    if (bmapi) {
      bmapi
        .getDistributionList({ userlist: listId })
        .then((resp) => {
          const newValues = {
            ...values,
            ...Object.keys(resp).reduce((accumulator, currentValue) => {
              if (values[currentValue] !== undefined) {
                accumulator[currentValue] = resp[currentValue];
              }
              return accumulator;
            }, {}),
          };
          setValues(newValues);
          const type = resp.dynamic ? "dynamic" : "static";
          setListType(type);
        })
        .catch((e) => {
          notifyError(getErrorMessageString(e, intl));
        });
    }
  }, [bmapi, intl, notifyError, listId, values]);

  const loadConsents = useCallback(() => {
    if (bmapi) {
      bmapi
        .getConsent()
        .then((resp) => {
          if (!resp) {
            resp = [];
            setConsentsList(resp);
          } else {
            setConsentsList(resp);
          }
        })
        .catch((e) => {
          notifyError(getErrorMessageString(e, intl));
        });
    }
  }, [bmapi, intl, notifyError]);

  useEffect(() => {
    loadList();
    loadConsents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadConsents]);

  const handleValues = useCallback(
    (varName) => (event) => {
      setValues({ ...values, [varName]: event.target.value });
    },
    [values]
  );

  const inputProps = {
    handleValues,
    staticType,
    consentsList,
    listType,
    dynamicType,
    values,
    setValues,
    listId,
  };

  return (
    <Container maxWidth="sm">
      <Title backUrl={MANAGER_ROUTES.DISTRIBUTION_LISTS}>
        {intl.formatMessage(common.modify)}{" "}
        {intlFormatMessage(distributionLists[listType], listType, intl)}
      </Title>
      {values && <DistributionListForm {...inputProps} />}
    </Container>
  );
}
